import React from 'react';
import { Layout } from 'antd';

const { Footer } = Layout;

const CustomFooter = () => {
  return (
    <Footer style={{ textAlign: 'center' }}>
      <a href="https://procheck.pk/" target="_blank" rel="noopener noreferrer" style={{ color: 'black' }}>
        Procheck
      </a>
        <br />
        Copyright © 2023
    </Footer>
  );
};

export default CustomFooter;
